export default __webpack_public_path__ + "static/media/fifth-strip.e65d1b83.png";